module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.3530/img/video-thumb-overlay.png"